module.exports = __webpack_public_path__ + "static/media/13H.caf0928f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/13H.svg
// module id = 47
// module chunks = 0